import './table.scss';
import merge from 'lodash/merge';
import debounce from 'lodash/debounce';

function Table(element) {
	this.ui = {
		element: element
	};

	this.settings = merge(
		{
			stateClasses: {
				isClickableRow: 'table__row--clickable',
				isClickableRowLink: 'table__row_link'
			},
			sortable: true,
			filterable: false,
			initiallyHidden: false
		},
		JSON.parse(this.ui.element.dataset.tableOptions || '{}')
	);

	this.init();
}

Table.prototype.init = function () {
	if (this.settings.initiallyHidden) {
		this.ui.element.style.display = 'block';
	}

	this._initLinkedRows();

	if (this.settings.sortable) {
		this._initSorting();
	}

	if (this.settings.filterable) {
		this._initFiltering();
	}
};

Table.prototype._initLinkedRows = function () {
	Array.prototype.slice
		.call(this.ui.element.querySelectorAll('[data-table="rowlink"]'))
		.forEach(link => {
			var row = link.closest('tr');

			row.classList.add(this.settings.stateClasses.isClickableRow);
			link.classList.add(this.settings.stateClasses.isClickableRowLink);

			row.addEventListener('click', event => {
				if (
					['a', 'button'].indexOf(event.target.nodeName.toLowerCase()) !== -1 ||
					event.target.closest('a, button')
				) {
					return;
				}

				link.dispatchEvent(new MouseEvent('click'));
			});
		});
};

Table.prototype._initSorting = function () {
	this.headers = Array.prototype.slice.call(this.ui.element.querySelectorAll('thead th'));
	this.body = this.ui.element.querySelector('tbody');
	this.rows = Array.prototype.slice.call(this.body.querySelectorAll('tr'));

	this.headers.forEach((header, i) => {
		var initialSort = header.getAttribute('data-table-sorted');

		header.classList.add('table__cell--sortable');

		if (initialSort) {
			var reverse = initialSort === 'desc';

			this._sort(i, reverse);

			header.setAttribute('sorted', reverse ? 'desc' : 'asc');
		}

		header.addEventListener('click', () => {
			var reverse = header.getAttribute('sorted') === 'asc';

			this._sort(i, reverse);

			header.setAttribute('sorted', reverse ? 'desc' : 'asc');
		});
	});
};

Table.prototype._sort = function (columnIndex, reverse) {
	this.rows
		.sort((a, b) => {
			var aText = this._getColumnText(a, columnIndex),
				bText = this._getColumnText(b, columnIndex);

			if (aText < bText) {
				return reverse ? 1 : -1;
			}
			if (aText > bText) {
				return reverse ? -1 : 1;
			}
			return 0;
		})
		.forEach(row => {
			this.body.appendChild(row);
		});

	this.headers.forEach(function (header) {
		header.removeAttribute('sorted');
	});
};

Table.prototype._getColumnText = function (row, columnIndex) {
	var field = row.querySelector('td:nth-child(' + (columnIndex + 1) + ')');

	return field.getAttribute('data-table-sort') || field.innerText;
};

Table.prototype._initFiltering = function () {
	const field = this.ui.element.querySelector('[data-table="filter"]');

	if (field && this.rows) {
		const lookup = this.rows.map(row => row.innerText.toLowerCase());

		field.addEventListener(
			'input',
			debounce(event => {
				const { value } = event.target;
				const matches = lookup.map(text => {
					const searchValue = value.toLowerCase();
					const isVisible = !searchValue || text.includes(searchValue);

					return isVisible;
				});

				this.rows.forEach((row, index) => {
					row.classList.toggle('is-hidden', !matches[index]);
				});
			}, 250)
		);
	}
};

const elements = document.querySelectorAll('[data-init="table"]');

elements.forEach(element => {
	new Table(element);
});

export default Table;
